import styled from 'styled-components';

import { Checkbox } from '@/ui/Checkbox';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`;

export const JourneyInsightsParticipantsBulkCheckbox = ({
  hasSelectedAllParticipants,
  onAllParticipantsIdsSelectedChange,
}: {
  hasSelectedAllParticipants: boolean;
  onAllParticipantsIdsSelectedChange: (selected: boolean) => void;
}): JSX.Element => (
  <RootStyled>
    <Checkbox
      checked={hasSelectedAllParticipants}
      onChange={() => onAllParticipantsIdsSelectedChange(hasSelectedAllParticipants)}
    />
  </RootStyled>
);
